import React, { Fragment, useEffect, useMemo } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router";
import { BASE_URL, HOST, SET_HOST } from "../../../constants/constants";
import { userLogout } from "../../../store/actions/auth/logout";
import Navbar from "./Navbar";
const NavigationBody = ({ userData, isAuthenticated, location, subjectData }) => {

  const dispatch = useDispatch();
  const history = useHistory();

  const oznakaDrzaveEid = useSelector((state) => state.authentication.userData?.oznakaDrzaveEid)



  const handleLogout = () => {
    dispatch(userLogout(() => history.push("/")));
  };

  const constructLogoutUrl = useMemo(() => {
    //ako nema oznake drzave, radi se o strancu 
    if (!oznakaDrzaveEid) {
      return userData?.oib ? `https://${HOST}/api/logout/${userData?.oib}` :
        ""
    }
    return `${BASE_URL}/api/logout/${userData.oib}`

  }, [])


  return (
    <Fragment>
      <Navbar
        loginUrl={`${BASE_URL}/api/login`}
        logoutUrl={
          constructLogoutUrl
        }
        messageId={userData?.inResponseTo}
        navToken={userData?.navToken}
        isAuthenticated={isAuthenticated}
        logout={handleLogout}
        changeEntityUrl
        BASE_URL={BASE_URL}
        forLegalIps={subjectData.forLegalIps}
        legalIzvor={subjectData.legalIzvor}
        personOib={subjectData.personOib}
        toLegalIps={subjectData.toLegalIps}
        toLegalIzvor={subjectData.toLegalIzvor}
        showEntitySearch={location.state?.showEntitySearch}
        userOib={userData?.oib}
      />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.authentication.userData,
    isAuthenticated: state.authentication.isAuthenticated,
    subjectData: state.authentication.subjectData
  };
};

export default connect(mapStateToProps)(withRouter(NavigationBody));
